import { User } from "shared/models/users/user";

export class LoginResponseDTO{
    accessToken: string = '';
    refreshToken: string = '';
    ambassador: User = new User();

    constructor(data: LoginResponseDTO){
        this.ambassador = new User(data.ambassador ?? {});
        this.accessToken = data.accessToken;
        this.refreshToken = data.refreshToken;
    }
}